import React, {useContext} from "react";
import BasketItem from "./BasketItem";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {BasketItemInterface} from "../../interfaces/core/BasketItemInterface";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

function Basket({positions}:{positions: BasketItemInterface[]}) {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const removeSelected = () => {
        const currentBasketPositions: BasketItemInterface[] = state.basket
        let currentBasketPositionsChanged = currentBasketPositions.filter(basketPosition => !basketPosition.isSelected)
        dispatch({type: ReducerActionType.SET_BASKET, payload: [...currentBasketPositionsChanged]})
    }

    const allSelected = positions.every(position => position.isSelected === true)

    const selectAll = () => {
        const shouldSelectAll = !allSelected
        const updatedBasketPositions = state.basket.map(basketPosition => ({
            ...basketPosition,
            isSelected: shouldSelectAll
        }))
        dispatch({type: ReducerActionType.SET_BASKET, payload: updatedBasketPositions})
    }

    return (<div className="basket__products bd">
        <div className="top">
            <div className={"form-checkbox basket-all-checks " + (allSelected && 'active')}>
                <label
                    className="label-dot"
                    htmlFor="check-basket-all-prod"
                    onClick={() => {
                        selectAll()
                    }}
                />
                <label className="label-text">
                    Выбрать все
                </label>
            </div>
            <a className="ico-cont" href="/" onClick={(event) => {
                event.preventDefault()
                removeSelected()
            }}>
                <i className="ico ico-left ico-trash"/>
                Удалить выбранные
            </a>
        </div>
        <div className="basket__products-list">
            {positions.map(position => <BasketItem
                key={position.itemId}
                position={position}
            />)
            }
        </div>
    </div>)
}

export default Basket